import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToHomePage } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getIsExternalLogin, getStoreSettingsCollection } from "@store/Store/Context/ContextSelectors";

replaceInChain(chain, RedirectToHomePage, (props) => {
	const isExternalLogin = getIsExternalLogin(props.getState());
	const settings = getStoreSettingsCollection(props.getState());
	
	/* Poolcorp Custom Code */
	if (isExternalLogin) {
		window.location.href = `${settings.poolcorpSettings.azureSsoSignoutUrl}?post_logout_redirect_uri=${window.location.origin}`;
	} else {
		RedirectToHomePage(props);
	}
	/* Poolcorp Custom Code */
});